import { Swiper, Navigation, Pagination, Autoplay, Lazy, EffectFade } from /* webpackPrefetch: true */ "swiper/core";
import(/* webpackPrefetch: true */ "swiper/swiper-bundle.min.css");

Swiper.use([Navigation, Pagination, Autoplay, Lazy, EffectFade]);

export default { Swiper };
